import { DomainSerializer } from "src/app/global/serializables/domain.serializer";
import { ArquivoImportacaoNovo } from "../domain/arquivo-importacao-novo.model";

export class ArquivoImportacaoNovoSerializer extends DomainSerializer<ArquivoImportacaoNovo> { }